import React from 'react';

function About() {
  const features = [
    {
      icon: '⭐',
      title: 'Expert Team',
      description: 'Certified developers with extensive experience in cutting-edge technologies'
    },
    {
      icon: '🎯',
      title: 'Client-Focused',
      description: 'Your success is our priority. We deliver solutions that drive results'
    },
    {
      icon: '⚡',
      title: 'Agile Delivery',
      description: 'Fast turnaround times with flexible, iterative development approach'
    },
    {
      icon: '🔒',
      title: 'Secure & Reliable',
      description: 'Industry-standard security practices and robust, scalable solutions'
    },
    {
      icon: '💬',
      title: 'Clear Communication',
      description: 'Transparent processes with regular updates throughout the project'
    },
    {
      icon: '🛠️',
      title: 'Ongoing Support',
      description: 'Comprehensive maintenance and support services post-launch'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-header">
          <div className="section-label">WHY CHOOSE US</div>
          <h2 className="about-title">Excellence in Every Line of Code</h2>
          <p className="about-description">
            At Techowdy LLC, we combine cutting-edge technology with business strategy 
            to deliver solutions that drive real results. Based in Montana, we serve 
            clients globally with world-class development services.
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-large">{feature.icon}</div>
              <h4 className="feature-title">{feature.title}</h4>
              <p className="feature-text">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default About;
